import React from "react";
import MaButton from "../../../../Components/UI/ma-button";
import { TfiDownload } from "react-icons/tfi";

function StatCard({ label, value, loading }) {
  const display =
    loading && (value === undefined || value === null) ? "—" : (value ?? 0);
  return (
    <div className="rounded-xl border border-[#EFEFEF] bg-white px-4 py-3 shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
      <p className="my-0 text-[11px] font-semibold uppercase tracking-wide text-[#9CA3AF]">
        {label}
      </p>
      <p className="my-0 mt-1 text-[20px] font-bold tabular-nums text-[#111827]">
        {display}
      </p>
    </div>
  );
}

export function ApprovalHeader({ onExport, orderStats, orderStatsLoading }) {
  return (
    <div className="mb-5 flex items-start justify-between gap-3 sm:mb-8 md:mb-10">
      <div className="min-w-0 flex-1">
        <h1 className="my-0 text-[20px] font-semibold tracking-tight text-[#0F0F0F] sm:text-[22px] md:text-[24px]">
          Product Approval
        </h1>
        <p className="my-0 mt-1 text-[12px] leading-relaxed text-[#6B7280] sm:mt-1.5 sm:text-[13px]">
          Track your product review status
        </p>
      </div>
      <MaButton
        startIcon={<TfiDownload className="text-[15px]" />}
        onClick={onExport}
        sx={{
          alignSelf: "flex-start",
          flexShrink: 0,
          textTransform: "none",
          color: "#151515",
          borderColor: "#E5E7EB",
          bgcolor: "#FFFFFF",
          border: "1px solid #E5E7EB",
          px: 2.5,
          fontWeight: 600,
          fontSize: "13px",
          "&:hover": {
            borderColor: "#D1D5DB",
            bgcolor: "#F9FAFB",
          },
        }}
      >
        Export
      </MaButton>
    </div>
  );
}
